// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header label="'Description'" header="'Add new access rule'"></sub-header>

  <table class="table">
    <tbody>
    <tr>
      <td>Actions</td>
      <td>
        <selectize options="\$ctrl.accessRulesDefinition"
                   config="\$ctrl.commandConfig"
                   ng-model="\$ctrl.commands">
        </selectize>
      </td>
    </tr>
    <tr>
      <td></td>
      <td>
        <button class="btn btn-primary"
                type="button"
                ng-click="\$ctrl.addCommands()">
          Add actions
        </button>
      </td>
    </tr>
    </tbody>
  </table>

  <form name="rulesConfig" ng-if="\$ctrl.accessRulesToConfigure.length > 0">
    <div class="alert" >
      Approval, OTP and extra conditions should be manually configured after adding basic configuration of access level for these actions.
    </div>

    <table class="table table-config">
      <thead>
      <th>Action</th>
      <th>Access Level</th>
      </thead>
      <tbody>
      <tr ng-repeat="rule in \$ctrl.accessRulesToConfigure | orderBy: 'displayName'">
        <td>{{rule.displayName}}</td>
        <td>
          <select ng-model="rule.executionType"
                  ng-options="o.value as o.label for o in \$ctrl.executionOptions"
                  class="role-write-access__execution_type"
                  required>
          </select>
          <help
            ng-class="{'invisible': rule.id}"
            title="'Execute by approval hierarchy' option will become available after access rule is saved"></help>
        </td>
      </tr>
      </tbody>
    </table>

    <div class="actions flex-end">
      <button type="button"
              class="btn btn-warning"
              ng-click="\$ctrl.navigateBackToGroupedList()">
        Cancel
      </button>
      <button type="button"
              class="btn btn-success"
              ng-disabled="rulesConfig.\$invalid"
              ng-click="\$ctrl.save()">
        Save
      </button>
    </div>
  </form>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/security/role-write-access/new-access-rule/new-access-rule.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;